import { useState, useEffect, useRef, useCallback } from "react";

export function useDivHeight<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [height, setHeight] = useState(0);

  const updateHeight = useCallback(() => {
    if (ref.current) {
      setHeight(ref.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    if (!ref.current) return;

    // Initial height
    updateHeight();

    // Use ResizeObserver to listen for height changes
    const observer = new ResizeObserver(() => {
      updateHeight();
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [updateHeight]);

  return { ref, height };
}
